import React from "react";
const LDAPAdapterDocumentation = () => /* @__PURE__ */ React.createElement("div", null);
export default LDAPAdapterDocumentation;
